module.exports = __webpack_public_path__ + "static/media/gif3.87528c29.gif";